import { CountriesListResponse } from '../features/dictionaries/types'
import { countries } from './countries'

interface CountryOption {
  value: string
  text: string
}

export const transformCountriesToOptions = (
  countriesList: CountriesListResponse | null,
): CountryOption[] => {
  // если с бэка ничего не пришло или пришла некорректная структура, используем справочник на фронте
  if (
    !countriesList ||
    typeof countriesList !== 'object' ||
    !('countries' in countriesList) ||
    countriesList.countries == null
  ) {
    return countries
  }

  const countriesFromList = countriesList.countries

  return Object.keys(countriesFromList).map((countryCode, index) => ({
    value: countryCode,
    text: countriesList.countries[countryCode].name,
    key: index,
  }))
}
